import { Component } from "react";
import * as UsersService from "../services/users/api_user";

class Logout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    UsersService.logout();
    window.location = "/";
  }

  render() {
    return null;
  }
}

export default Logout;



// WEBPACK FOOTER //
// ./src/User/Logout.jsx